import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VIcon,{staticClass:"delete",attrs:{"small":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteItem()}}},[_vm._v(" fas fa-trash ")])
}
var staticRenderFns = []

export { render, staticRenderFns }